export const SET_CLEAR_ALL_STATE = 'SET_CLEAR_ALL_STATE';
export const SET_LOADING_FILE_RSO = 'SET_LOADING_FILE_RSO';
export const SET_GET_FILE_RSO = 'SET_GET_FILE_RSO';
export const SET_ERROR_RSO = 'SET_ERROR_RSO';
export const SET_DATA = 'SET_DATA';
export const SET_FILE = 'SET_FILE';
export const SET_EXCEL_PREVIEW_DATA = 'SET_EXCEL_PREVIEW_DATA';
export const SET_EXCEL_PREVIEW_COLUMNS = 'SET_EXCEL_PREVIEW_COLUMNS';
export const SET_COLUMN_LABELS = 'SET_COLUMN_LABELS';
export const SET_HIGHLIGHTED_COLUMNS = 'SET_HIGHLIGHTED_COLUMNS';
export const CLEAR_HIGHLIGHTED_COLUMNS = 'CLEAR_HIGHLIGHTED_COLUMNS';
export const SET_HIGHLIGHTED_ROWS = 'SET_HIGHLIGHTED_ROWS';
export const CLEAR_HIGHLIGHTED_ROWS = 'CLEAR_HIGHLIGHTED_ROWS';
export const SET_VALUE_FORM = 'SET_VALUE_FORM';
export const SET_ROW_LABELS = 'SET_ROW_LABELS';
